import ReportSectionContent from "../../../components/UI/ReportSectionContent";
import { examCardEnums } from "../../../enums";
import EyeReport from "./EyeReport";

const SynoptophoreReport = () => {
  return (
    <ReportSectionContent
      sectionName={examCardEnums.SYNOPTOPHORE.sectionName}
      EyeReport={<EyeReport />}
    />
  );
};

export default SynoptophoreReport;
